import _ from "lodash";
import { CustomerLocation } from "../models/Booking/CustomerLocation";
import { Customer } from "../models/Booking/Customer";

/**
 * Class for work with Customer locations
 */
export default class Locations {

    public static getById(locationId : number) {

    }

    
    /**
     * Update location in Customer object and return it
     * @param customer 
     * @param newLocation 
     * @returns Customer with updated location
     */
    public static update(customer : Customer, newLocation : CustomerLocation) : Customer {
        customer.locations = (customer.locations || []).map((it : any) => it.id === newLocation.id ? newLocation : it);
        return customer;
    }

    /**
     * Check exist location or not
     * @param customer 
     * @param location 
     * @returns 
     */
    public static has(customer: Customer, location : CustomerLocation) : boolean {
        return !!(customer.locations || []).find((it : any) => it.id === location.id);
    }

    /**
     * @returns Primary location of Customer or undef
     */
    public static getPrimary(customer : Customer) : CustomerLocation {
        let location : CustomerLocation;
        location = _.find(customer?.locations || [], { primary: true }) || new CustomerLocation();
        return location;
    }

    /**
     * Add location to customer locations array if it not exist
     * @param customer 
     * @param location 
     * @returns 
     */
    public static setIfNotExist(customer: Customer, location : CustomerLocation) : Customer {
        const exist = !!(customer.locations || []).find((it : any) => it.id === location.id);

        if ( !exist ) {
            customer.locations = customer.locations || [];
            customer.locations?.push(location);
        }

        return customer;
    }

    public static setIfNotExistOrUpdate(customer: Customer, location : CustomerLocation) : Customer {
        const exist = !!(customer.locations || []).find((it : any) => it.id === location.id);

        if ( !exist ) {
            customer.locations = customer.locations || [];
            customer.locations?.push(location);
        } else {
            return Locations.update(customer, location);
        }

        return customer;
    }


    /**
     * Set primary field to true for passed location
     * @param customer 
     * @param location 
     * @returns 
     */
    public static setPrimaryLocation(customer : Customer, location : CustomerLocation) : Customer {
        customer.locations = (customer.locations || []).map((it : any) => it.id === location.id ? {
            ...location,
            primary : true
        } : {
            ...it,
            primary : false
        });

        return customer;
    }

    /**
     * @param customer 
     * @returns Primary location as string
     */
    public static getPrimaryAsString(customer : Customer) : string {
        const location = Locations.getPrimary(customer);

        return `${location.apartment ? location.apartment + ' ' : ''}${location.street ? location.street + ' ' : ''}${location.city ? location.city + ', ' : ''}${location.zip ? location.zip + ' ' : ''}${location.state ? location.state : ''}`;
    }

}
